import React from 'react';
import { ReactComponent as CaseIcon } from 'shared/assets/icons/case.svg';
import { ReactComponent as SunIcon } from 'shared/assets/icons/sun.svg';
import { CalendarEventDTO } from '../api';

export const getEventTypeIcon = (type: CalendarEventDTO['exclusionType']): React.ReactElement => {
  switch (type) {
    case 'NON_WORKING_DAY':
      return <SunIcon />;
    case 'WORKING_DAY':
    default:
      return <CaseIcon />;
  }
};
